<template lang="pug">
.product-variations
  CardMinimal(:title="$t('products.has_variations')", :key="variationsKey")
    .p-a-4
      FormRadio(:items="variationSelection", @input="setVariationSelection($event)")
  CardMinimal(:title="$t('products.attributes')", v-if="variationSelection[1].selected === true").m-t-4
    .p-a-4.attributes(:class="`${attributesError ? 'error' : ''}`")
      FormTags(:placeholder="$t('products.add_attribute')", :hint="$t('products.attributes_hint')", :existingTags="data.attributes" @data="setAttributes($event)", :limit="10")
  CardMinimal(:title="variationSelection[1].selected === true ? $t('products.variations') : $t('products.stock')").m-t-4
    .variation(v-for="(variation, index) in data.variations", :key="index", :class="`${variationError === index ? 'error' : ''}`").p-x-4.p-t-4.p-b-2
      .variation-info
        template(v-if="variation.deleted")
          .status
            i.mdi.mdi-trash-can-outline.red
            | {{ $t('products.removing') }}
        //template(v-else)
          .status
            i.mdi(:class="`mdi-${variation.active ? 'check-circle green' : 'pause-circle orange'}`")
            | {{ variation.active ? $t('products.active') : $t('products.paused') }}
        .dropdown-input(:class="`${variation.inventory.type === 'infinite' ? 'keep-all-rounded' : ''}`")
          FormDropdown(:items="stockTypes", :value="variation.inventory.type", @input="setStockType(index, $event)")
          FormInput(size="1", type="number", v-if="variation.inventory.type === 'finite'", v-model="data.variations[index].inventory.quantity" placeholder="0", @input="setQuantity(index, $event)").small.center-text
        .dots-wrapper.p-l-2.ml-a(v-if="data.variations.length > 1")
          Dots(ref="dots").left
            ul
              template(v-if="variation.deleted")
                li.red(@click="undoRemove(index)")
                  i.mdi.mdi-trash-can-outline
                  | {{ $t('products.undo_remove') }}
              template(v-else)
                li.red(@click="remove(index)", v-if="variationSelection[1].selected === true")
                  i.mdi.mdi-trash-can-outline
                  | {{ $t('products.remove') }}
                //li(:class="`${variation.active ? 'orange' : 'green'}`", @click="toggleActive(index)")
                  i.mdi(:class="`mdi-${ variation.active ? 'pause-circle' : 'check-circle'}`")
                  | {{ variation.active ? $t('products.pause') : $t('products.activate') }}
      .variation-attributes(v-if="variationSelection[1].selected === true")
        FormInput(v-for="(attribute, aindex) in data.attributes", :key="`${index}-${aindex}`", :placeholder="attribute", v-model="data.variations[index].attributes[attribute]", :id="`variation-${index}-${attribute}`", @input="setAttribute(index)")
    .p-a-4.d-f.ai-c.jc-c(@click="addNewVariation" slot="footerButton", :class="`${data.variations.length === 0 ? 'all-round' : ''}`", v-if="variationSelection[1].selected === true")
      i.mdi.mdi-plus-circle
      span {{ data.variations.length === 0 ? $t('products.add_variation') : $t('products.add_additional_variation') }}
</template>

<script>

import Dots from '@/components/Dots.vue';

export default {
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dots,
  },
  methods: {
    async update() {
      const { attributes, variations: sku } = this.gatherData();

      this.setAttributes(attributes);

      const newSKU = sku.filter(variation => typeof variation.edited === 'undefined' && typeof variation.deleted === 'undefined');
      const updateSKU = sku.filter(variation => variation.edited && !variation.deleted);
      const deleteSKU = sku.filter(variation => variation.deleted);

      await this.$store.dispatch('Products/updateAttributes', {
        id: this.editData.id,
        payload: attributes,
      });

      let failedUpdate = false;

      for (let i = 0; i < newSKU.length; i += 1) {
        // eslint-disable-next-line
        const result = await this.$store.dispatch('Products/createSKU', newSKU[i]);
        if (!result) {
          failedUpdate = true;
        }
      }

      for (let i = 0; i < updateSKU.length; i += 1) {
        const { active, attributes, inventory } = updateSKU[i];
        // eslint-disable-next-line
        const result = await this.$store.dispatch('Products/updateSKU', { id: updateSKU[i].id, payload: { active, attributes, inventory } });
        if (!result) {
          failedUpdate = true;
        }
      }

      for (let i = 0; i < deleteSKU.length; i += 1) {
        // eslint-disable-next-line
        const result = await this.$store.dispatch('Products/deleteSKU', deleteSKU[i].id);
        if (!result) {
          failedUpdate = true;
        }
      }

      if (failedUpdate) {
        // eslint-disable-next-line
        return false;
      }

      return true;

    },
    reset() {
      if (this.editData && this.edit) {
        const { attributes, sku } = this.editData;

        if (attributes.length > 0) {
          this.data.attributes = attributes;
          this.setVariationSelection({ index: 1 });
        }

        this.data.variations = sku ? sku.map(variation => Object.assign(variation, { edited: false, deleted: false })) : [];

        this.variationsKey += 1;
      }
    },
    setVariationSelection({ index }) {
      for (let i = 0; i < this.variationSelection.length; i += 1) {
        this.variationSelection[i].selected = index === i;
      }
    },
    setAttribute(index) {
      if (typeof this.data.variations[index].edited !== 'undefined') {
        this.data.variations[index].edited = true;
      }
    },
    setQuantity(index, value) {
      if (typeof this.data.variations[index].edited !== 'undefined') {
        this.data.variations[index].edited = true;
      }
      this.data.variations[index].inventory.quantity = parseInt(value, 10);
    },
    /**
     * Set attributes
     * @param {Array} attributes
     */
    setAttributes(arr) {
      this.data.attributes = arr;
      const { variations } = this.data;
      for (const [_, variation] of variations.entries()) {
        for (const attribute in variation.attributes) {
          if (!arr.includes(attribute)) {
            delete variation.attributes[attribute];
            variation.edited = true;
          }
        }
      }
    },
    addNewVariation() {
      const variation = {
        attributes: {},
        active: true,
        inventory: {
          type: 'infinite',
        },
      };

      if (this.edit) {
        Object.assign(variation, {
          product_id: this.editData.id,
        });
      }

      this.data.variations.push(variation);
    },
    undoRemove(index) {
      this.data.variations[index].deleted = false;
      this.variationsKey += 1;
      this.$refs.dots[index].close();
    },
    remove(index) {
      if (typeof this.data.variations[index].deleted !== 'undefined') {
        this.data.variations[index].deleted = true;
        this.variationsKey += 1;
      } else {
        this.data.variations.splice(index, 1);
      }
      this.$refs.dots[index].close();
    },
    toggleActive(index) {
      this.data.variations[index].active = !this.data.variations[index].active;
      if (typeof this.data.variations[index].edited !== 'undefined') {
        this.data.variations[index].edited = true;
      }
      this.$refs.dots[index].close();
    },
    setStockType(index, { value }) {
      this.data.variations[index].inventory.type = value; 
    },
    /**
     * Validate variations
     */
    async validate() {
      this.variationError = null;
      this.attributesError = false;

      const { attributes, variations } = this.data;
      const hasVariations = this.variationSelection.find(s => s.selected);

      if (hasVariations.value && attributes.length === 0) {
        this.attributesError = true;
      }
      
      for (const [index, variation] of variations.entries()) {
        if (hasVariations.value && attributes.length > 0) {
          for (const [_, attribute] of attributes.entries()) {
            if (typeof variation.attributes[attribute] === 'undefined' || variation.attributes[attribute] === '') {
              this.variationError = index;
              return false;
            }
          }
        }
      }

      return true;
    },
    /**
     * Gather data
     */
    gatherData() {

      const { attributes, variations } = this.data;
      const hasVariations = this.variationSelection.find(s => s.selected);
      const data = {
        attributes: hasVariations.value ? attributes : [],
        variations,
      };

      return data;
    },
    /**
     * Emit data to parent
     */
    emit() {
      const data = this.gatherData();
      this.$emit('data', data);
    },
  },
  watch: {
    'data': {
      deep: true,
      handler() {
        this.emit();
      },
    },
  },
  data() {
    return {
      variationsKey: 0,
      data: {
        attributes: [],
        variations: [],
      },
      variationError: null,
      attributesError: false,
      variationSelection: [
        { value: false, string: this.$t('products.product_has_no_variations'), selected: true },
        { value: true, string: this.$t('products.product_has_variations'), selected: false },
      ],
      stockTypes: [
        { value: 'infinite', string: this.$t('products.unlimited_stock') },
        { value: 'finite', string: this.$t('products.stock') }
      ],
    };
  },
  mounted() {
    if (this.edit) {

      const { attributes, sku } = this.editData;

      if (attributes.length > 0) {
        this.data.attributes = attributes;
        this.setVariationSelection({ index: 1 });
      }

      this.data.variations = sku ? sku.map(variation => Object.assign(variation, { edited: false, deleted: false })) : [];
    } else {
      this.addNewVariation();
    }
  },
  beforeDestroy() {
    this.$emit('data', null);
  },
};
</script>

<style lang="scss" scoped>
.dots-wrapper {
  justify-content: flex-end;
  display: flex;
  line-height: 30px;
  order: 1;
  margin-top: 3px;
}

.attributes {
  &.error {
    background-color: rgba(#D0021B, .2);
    border-radius: 10px;
  }
}

.variation {
  border-top: 1px solid #E7E9EC;

  &:first-child {
    border-top: 0;
  }

  &.error {
    background-color: rgba(#D0021B, .2);
  }

  .status {
    order: 0;
    align-items: center;
    display: flex;
    font-size: 16px;
    min-width: 110px;
    line-height: 30px;

    i {
      font-size: 30px;
      margin-right: .25rem;

      &.red {
        color: #D0021B;
      }

      &.green {
        color: #00BB5F;
      }

      &.orange {
        color: #FF8429;
      }
    }
  }

  .variation-attributes {
    display: flex;
    flex-wrap: wrap;
    order: 1;
    width: 100%;

    & > * {
      width: calc(50% - 5px);
      margin-bottom: 10px;
      margin-left: 5px;

      &:nth-child(2n+1) {
        margin-left: 0;
      }
    }

    @media (min-width: 570px) and (max-width: 767px), (min-width: 900px) and (max-width: 1017px), (min-width: 1150px) {
      order: 0;
      & > * {
        width: calc(33% - 5px);

        &:nth-child(2n+1) {
          margin-left: 5px;
        }

        &:nth-child(3n+1) {
          margin-left: 0;
        }
      }
    }
  }

  .variation-info {
    display: flex;
    margin-bottom: 10px;
  }
}
</style>